import { Button, createStyles, makeStyles, Theme } from "@material-ui/core";
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { Note, notes } from "../util/keys";

export type Props = {
    selectedTonic?: Note
    onSelected: (tonic: Note) => void
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            '& > *': {
                margin: theme.spacing(1),
            },
        },
    }),
);

const TonicSelector: React.FC<Props> = ({ selectedTonic, onSelected }) => {
    const classes = useStyles();

    return <div className={classes.root}>
        <ButtonGroup color="primary">
            {notes.map((note, i) =>
                <Button key={note} onClick={() => onSelected(note)} variant={selectedTonic === note ? "contained" : "outlined"} color={selectedTonic === note ? 'primary' : undefined}>{note}</Button>
            )}
        </ButtonGroup>
    </div>
}

export default TonicSelector;